import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _noop from "lodash/noop";
import { DescendantsProvider, useControlledComponent, useDescendant } from "../../hooks";
import React, { createContext, useContext, useMemo, useState } from 'react';
import { useId } from "../../utils";
export var AccordionDialogContext = createContext({
  value: null,
  onChange: _noop,
  size: 'medium'
});
export var AccordionDialogController = function AccordionDialogController(_ref) {
  var children = _ref.children,
      expanded = _ref.expanded,
      onExpandedChange = _ref.onExpandedChange,
      defaultExpanded = _ref.defaultExpanded,
      size = _ref.size;

  var _useControlledCompone = useControlledComponent(expanded, onExpandedChange, defaultExpanded),
      _useControlledCompone2 = _slicedToArray(_useControlledCompone, 2),
      value = _useControlledCompone2[0],
      setValue = _useControlledCompone2[1];

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      descendants = _useState2[0],
      setDescendants = _useState2[1];

  var context = useMemo(function () {
    return {
      value: value,
      onChange: setValue,
      size: size
    };
  }, [value, setValue, size]);
  return /*#__PURE__*/React.createElement(DescendantsProvider, {
    descendants: descendants,
    setDescendants: setDescendants
  }, /*#__PURE__*/React.createElement(AccordionDialogContext.Provider, {
    value: context
  }, children));
};
export var useAccordionDialogContext = function useAccordionDialogContext(ref, idProp) {
  var id = useId(idProp);

  var _useDescendant = useDescendant(id, ref),
      index = _useDescendant.index;

  var _useContext = useContext(AccordionDialogContext),
      value = _useContext.value,
      _onChange = _useContext.onChange,
      size = _useContext.size;

  return {
    index: index,
    onChange: function onChange() {
      return _onChange(id);
    },
    size: size,
    expanded: value === id,
    id: id
  };
};